export default __webpack_public_path__ + "3eb34ba297737e920fbb20d3c8568af4.png";